import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
function AnchorStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary6 = _getThemeData.primary6,
    titleColor1 = _getThemeData.titleColor1,
    titleColor2 = _getThemeData.titleColor2,
    lineColor1 = _getThemeData.lineColor1;
  var _getThemeData2 = getThemeData(props, 'anchor'),
    fontSize = _getThemeData2.fontSize,
    fontWeight = _getThemeData2.fontWeight;
  return css([".c7n-anchor-wrapper.c7n-anchor-wrapper{.c7n-anchor{.c7n-anchor-ink{:before{width:0.01rem;background-color:", ";}.c7n-anchor-ink-ball{border-color:", ";}}.c7n-anchor-link{padding:0rem 0 0rem 0.12rem;.c7n-anchor-link{padding-top:0;padding-bottom:0;}.c7n-anchor-link-title{color:", ";font-size:", "px;text-decoration:none;padding:0.08rem 0 0.07rem;margin-bottom:0;&:hover{color:", ";}&.c7n-anchor-link-title-active{color:", ";text-decoration:none;font-weight:", ";}}}}}"], lineColor1, primary6, titleColor2, fontSize, primary6, titleColor1, fontWeight);
}
export default AnchorStyle;